const pathname = window.location.pathname;

export default () => {
  return {}
}
